/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer } from "react";
import { mapAndJoinArray } from "../../util/helperFunctions";


import * as R from "rambda";
const sensor_filter = `sensor.excludeFromUi = 0`

const emptyState = (key) => {
    const filtered_Data = JSON.parse(sessionStorage.getItem(key));

    return {
        site: (filtered_Data && filtered_Data['site']) ? [...filtered_Data['site']] : [],
        unit: (filtered_Data && filtered_Data['unit']) ? [...filtered_Data['unit']] : [],
        productionUnit: (filtered_Data && filtered_Data['productionUnit']) ? [...filtered_Data['productionUnit']] : [],
        equipment: (filtered_Data && filtered_Data['equipment']) ? [...filtered_Data['equipment']] : [],
        position: (filtered_Data && filtered_Data['position']) ? [...filtered_Data['position']] : [],
        cml: (filtered_Data && filtered_Data['cml']) ? [...filtered_Data['cml']] : [],
        fluid: (filtered_Data && filtered_Data['fluid']) ? [...filtered_Data['fluid']] : [],
        material: (filtered_Data && filtered_Data['material']) ? [...filtered_Data['material']] : [],
        corrosionLoop: (filtered_Data && filtered_Data['corrosionLoop']) ? [...filtered_Data['corrosionLoop']] : [],
    };
}

const reducer = (state, action) => {
    switch (action.type) {
        case "site":
            return { ...state, site: action.value };
        case "productionUnit":
            return { ...state, productionUnit: action.value };
        case "unit":
            return { ...state, unit: action.value };
        case "equipment":
            return { ...state, equipment: action.value };
        case "position":
            return { ...state, position: action.value };
        case "cml":
            return { ...state, cml: action.value };
        case "fluid":
            return { ...state, fluid: action.value };
        case "material":
            return { ...state, material: action.value };
        case "corrosionLoop":
            return { ...state, corrosionLoop: action.value };
        case "clear":
            return emptyState(action.key);
        default:
            throw Error("Unrecognized action: " + action.type);
    }
};

const applyFilter = (key, value) => {
    const mapAndJoinArray = (arr) => {
                return arr.map(item => `'${item.value}'`).join(", ");
            };
    switch (key) {
        case "unit":
            return `sensor.unit IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "site":
            return `sensor.site IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "productionUnit":
            return `sensor.productionUnit IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "equipment":
            return `sensor.equipment IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "corrosionLoop":
            return `sensor.corrosionLoop IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "position":
            return `sensor.position IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "cml":
            return `sensor.conditionMonitoringLocation IN  (${mapAndJoinArray(value)}) AND ${sensor_filter}`;
        case "fluid":
            return `nominal.fluid IN  (${mapAndJoinArray(value)})`;
        case "material":
            return `nominal.material IN  (${mapAndJoinArray(value)})`;
        default:
            throw Error("Unhandled filter field: " + key);
    }
};


const applyCancuiFilter = (key, value) => {
    const mapAndJoinArray = (arr) => {
                return arr.map(item => `'${item.value}'`).join(", ");
            };
    switch (key) {
        case "unit":
            return `unit IN  (${mapAndJoinArray(value)})`;
        case "site":
            return `site IN  (${mapAndJoinArray(value)})`;
        case "productionUnit":
            return `production_unit IN  (${mapAndJoinArray(value)})`;
        case "equipment":
            return `equipment IN  (${mapAndJoinArray(value)})`;
        default:
            throw Error("Unhandled filter field: " + key);
    }
};

const applyModelFilter = (key, value) => {
    const mapAndJoinArray = (arr) => {
                return arr.map(item => `'${item.value}'`).join(", ");
            };
    switch (key) {
        case "unit":
            return `sensor.unit IN  (${mapAndJoinArray(value)})`;
        case "site":
            return `sensor.site IN  (${mapAndJoinArray(value)})`;
        case "productionUnit":
            return `sensor.productionUnit IN  (${mapAndJoinArray(value)})`;
        case "equipment":
            return `sensor.equipment IN  (${mapAndJoinArray(value)})`;
        case "corrosionLoop":
            return `sensor.corrosionLoop IN  (${mapAndJoinArray(value)})`;
        case "cml":
            return `sensor.conditionMonitoringLocation IN  (${mapAndJoinArray(value)})`;
        default:
            throw Error("Unhandled filter field: " + key);
    }
};

const checkEmpty = (field) => {
    return (
        field === undefined ||
        field === "" ||
        field == null ||
        (field.length != null && field.length === 0)
    );
};

export const useFilterSensorState = (key) => {
    return useReducer(reducer, emptyState(key));
};

export const FilterSensorLogic = (source, isModel, isCancui) => {
    const filters = R.keys(source).map((key) => {
        const isEmpty = checkEmpty(source[key]);
        return !isEmpty ? (isModel ? applyModelFilter(key, source[key]) : isCancui ? applyCancuiFilter(key, source[key]) : applyFilter(key, source[key])) : null;
    });

    const result = R.filter(R.identity, filters).join(" AND ");
    return result;
};

export function useUpdatedFilterValues(filter, filterFormValues, getOptionsForFilter, updateFilters, noFilter) {
    // Get the current options for this filter
    const currentOptions = getOptionsForFilter(filter);

    // Filter out any selected values that are no longer in the updated options
    let updatedValues = filterFormValues[filter]
        ? filterFormValues[filter].filter(value =>
            currentOptions.find(option => option.value === value.value)
        )
        : [];

    if (updatedValues?.length > 0) {
        updatedValues = updatedValues.map(value => currentOptions.find(option => option && option.value === value.value))

    }

    // Update the filter form values
    useEffect(() => {
        if (!noFilter) {
            updateFilters({ type: filter, value: updatedValues });
        }
    }, [currentOptions]);


    return updatedValues;
}